import { useEffect, useRef } from 'react'
import { setPreference, usePreference } from '@fs/zion-preferences'

export const CET_ACCESS_PREFERENCE = 'tree.cetTest'

/**
 * Persists `tree.cetTest` once a user has earned access to the user trees (CET) experience.
 *
 * @param {boolean} shouldPersist - Whether the caller's conditions for granting CET access are met
 * @returns {void}
 */
export default function usePersistCetAccess(shouldPersist) {
  const cetAccessPreference = usePreference(CET_ACCESS_PREFERENCE)
  const hasPersistedRef = useRef(false)

  useEffect(() => {
    // `usePreference` is undefined until it loads and `''` when unset, so only `''` is safe to write over
    if (shouldPersist && cetAccessPreference === '' && !hasPersistedRef.current) {
      // Claim before the request so a re-render mid-flight cannot start a second write
      hasPersistedRef.current = true

      setPreference(CET_ACCESS_PREFERENCE, true).catch((error) => {
        // Release so a failed write can be retried
        hasPersistedRef.current = false
        console.error(error)
      })
    }
  }, [cetAccessPreference, shouldPersist])
}
